import { EquipmentService, ModelService, ManufacturerService,  MessageService,FacilityService } from 'src/app/services';
import { Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, HostListener, ElementRef, ViewChild } from '@angular/core';
import { SelectItem } from 'primeng/api/selectitem';
import { EquipmentInfo, EuqipmentHistoryData, MPI, SelectedData } from 'src/app/models/equipments/EquipmentInfo'
import { MenuItem } from 'primeng/api/menuitem';
import { DatePipe } from '@angular/common';
import {AccessUserInfo, UserDetail, UserFacility, UserLocationFacility } from 'src/app/models';
import {  Table} from 'primeng/table';
@Component({
  selector: 'bart-searchequipment',
  templateUrl: './searchequipment.component.html',
  styleUrls: ['./searchequipment.component.scss'],
  providers: [DatePipe]
})
export class SearchequipmentComponent implements OnInit {

  @ViewChild('Searchtb', { static: false }) searchtb: Table;

  constructor(
    private _EquipmentService: EquipmentService,
    private datePipe: DatePipe,
    private _modelService: ModelService,
    private _manufacturerService: ManufacturerService,   
    private _messageService: MessageService,
    private _facilityService:FacilityService,
    ) {
    this.EquipmentMpi = new MPI();
  }
  FaceilityMangerParams = {
    EquipmentIDList: "",
    facilityMasterIdList: "",
    manufacturerId: 0,
    modelId: 0,
    SerialNumber: "",
    UserName: null,
    SearchTerm: null,
    equipmentStatusId: null,
    MachineNickName: null,
    MachineIPAddress: null
  };

  index:number=0;
  first: number = 0;
  FaceilityMangerData: EquipmentInfo[] = [];
  selectedEquipmentData: any;
  public userId: number = 0;
  public cities1: SelectItem[];
  public userFacilities: SelectItem[];
  public selectedFacility: string;
  public strkeyWord123: string;
  public IsVisible: boolean = false;
  public IsEditable: boolean = false;
  public HoursIsEditable: boolean = false;
  public IsViewMode: boolean = true;
  public displayHistoryPopUp: boolean = false;
  public equipmentId: number;
  public Datetime: Date;
  public ValidationMsg: any[];
  public Alertpopup: boolean = false;
  public Loding: boolean = false;
  public Alertmessage: string = ''
  public HeaderText: string = ''
  public showScheduleOverRideReason:boolean=false;
  public editCustomSchedule :boolean=false
  public StatusReasonCodeComment: string = ''
   FIELDPRIVS = {		
		ADMIN:	"equipmentStatusId,equipmentSerialNumber,equipmentDescription,equipmentModality,manufacturerId,modelId,dateWarrantyExpires,saveBtn,equipmentModel,equipmentManufacturer,equipmentHours,equipmentOriginalInstallation,customScheduleEnableRow,customScheduleReasonRow,equipmentCondition,equipmentOrigin,mpi,confirmMpi,startDateMpi,endDateMpi,mpiCorrectionRow",
		
		BSS:	"",
		BSSX:	"",
		BOM:	"equipmentStatusId,equipmentSerialNumber,equipmentDescription,equipmentModality,manufacturerId,modelId,dateWarrantyExpires,saveBtn,equipmentModel,equipmentManufacturer,equipmentHours,equipmentOriginalInstallation,customScheduleEnableRow,customScheduleReasonRow,mpi,confirmMpi,startDateMpi,endDateMpi,mpiCorrectionRow",
		ANALYST: "",
		HHD: "equipmentStatusId,equipmentSerialNumber,equipmentDescription,equipmentModality,saveBtn,equipmentModel,equipmentManufacturer,equipmentHours,equipmentOriginalInstallation,mpi,confirmMpi,startDateMpi,endDateMpi,mpiCorrectionRow",
    BOMX:	"equipmentStatusId,equipmentSerialNumber,equipmentDescription,equipmentModality,saveBtn,equipmentModel,equipmentManufacturer,equipmentHours,equipmentOriginalInstallation,mpi,confirmMpi,startDateMpi,endDateMpi,mpiCorrectionRow"
    };
    
  GetEquipmentID = {
    EquipmentID: null
  };
  GetModelID = {
    ModelID: null
  };
  GetManfactureID = {
    manufacturerId: null
  }
  GETEQUIPMENTSTATUSID = {
    equipmentId: null,
  }
  UPDATEEQUIPMENTLOCATION = {
    equipmentId: null,
    facilityMasterId: null,
    equipmentStatusId: null,
    locationdescription: null,
    userid: null,
    dateModified: null
  }
  validateSerialPara = {
    ModelID: null,
    serial: null,
    strippedSerial: null
  }
  public ModelID: number;
  public ManfactureID: number;
  display: boolean = false;
  items: MenuItem[];
  FaceilityMangerColumns: any[];
  RepairResultColumns: any[];
  EuqipmentHistoryColumns: any[];
  SecheduleHistoryColumns: any[];
  RepairResultHistoryData: any[];
  EuqipmentHistory: any[];
  ScheduleHistory: any[];
  EquipmentMpi: MPI;
  ModelSchedule: any[];
  SelectedRowData: SelectedData;
  GetequipmentSchedule: any[] = [];
  public isMpiStartDateCorrection: boolean = false;
  public DisableMpi: boolean = false;
  Parameters = {
    isActiveFlag: "1"
  }
  EquipmentSchedulePara = {	
    EquipmentId: null,
    isScheduleActiveFlag: null,
    //DateModified: null,    
    OverrideReason: null,
    userId: null,
  }

  UpdateMPIData = {
    EquipmentID: null,
    EquipPatientID: null,
    PatientID: null,
    StartDate: '',
    EndDate: ''
  }
  UpdateEquipmentData = {
    equipmentStatusId: null,
    equipmentSerialNumber: null,
    equipmentDescription: null,
    userid: null,
    equipmentModalityId: null,
    equipmentConditionId: null,
    equipmentOriginId: null,
    modelId: null,
    dateWarrantyExpires: null,
    dateOfOriginalInstall: null,
    lastClockHours: null,
    isPMScheduleActiveFlag: null,
    isCustomScheduleActiveFlag: null,
    equipmentId: null,
    MachineNickName: null,
    ActuatorVersion: null,
    GeneralSoftwareVersion: null,
    FunctionalVersion: null,
    MachineIPAddress: null,    
  };
  ModelInfo: any[];
  model: any[];
  manufacturarsList: SelectItem[];
  ModelList: SelectItem[];
  StatusList: SelectItem[];
  ModalityList: SelectItem[];
  ConditionList: SelectItem[];
  OriginList: SelectItem[];
  public EnableCustomSchedule: boolean = false;
  public srText: string = '';
  public custText: string = '';
  public errors: string = '';
  public ValidationMsgDailogbox: boolean = false;
  public equipStatusChanged: boolean = false;
  public StausDailogbox: boolean = false;
  public isPaginatorVisible: boolean = false;
  public userName: string = '';
  public isDirtyMpi: number;
  bartRoleCode: string;
  bartRoleId: number;
  firstName: string = ""
  lastName: string = "";
  public ret = {
    Status: false,
    msg: "",
  }
  ngOnInit() {
    let userInfo:UserDetail = AccessUserInfo.getUserInfo();
    if (userInfo != null) {
      this.userId = userInfo.userId
      this.bartRoleCode = userInfo.bartRoleCode
      this.userName = userInfo.userName
      this.bartRoleId = userInfo.bartRoleId
      // this.firstName = userInfo.firstName;
      // this.lastName = userInfo.lastName;
    }
    this.userFacilities = [];
    this.Datetime = new Date()
    // this.GetFaceilityManger();
    this.GetManufacturar();
    this.getEquipmentConditions();
    this.getEquipmentModality();
    this.getModelDroDown();
    this.GetEquipmentStatus();
    this.getEquipmentOrigins();


    this.FaceilityMangerColumns = [
      { field: 'ManufacturerName', header: 'Manufacturer' },
      { field: 'modelNumber', header: 'Model' },
      { field: 'EquipmentSerialNumber', header: 'SN/IntID' },
      { field: 'MPI', header: 'MPI' },
      { field: 'facilityName', header: 'Location' },
      { field: 'EquipmentTypeDescription', header: 'Equip. Type' },
      { field: 'EquipmentSubTypeDescription', header: 'Sub-Type' },
      { field: 'status', header: 'Status' },
      { field: 'equipmentDescription', header: 'Equipment Description' },


    ];
    this.RepairResultColumns = [
      { field: 'TicketId', header: 'Ticket' },
      { field: 'WorkTypeDescription', header: 'Work Type' },
      { field: 'Sqadescription', header: 'SQA Code' },
      { field: 'DateServicePerformed', header: 'Repair Date' },
      { field: 'FullName', header: 'Repaired By' },
      { field: 'TicketStatusDescription', header: 'Ticket Status' },

    ];
    this.EuqipmentHistoryColumns = [


      { field: 'DateLocationChanged', header: 'Date' },
      { field: 'EquipmentStatusDescription', header: 'Status' },
      { field: 'FacilityName', header: 'Location' },
      { field: 'MachineIpaddress', header: 'IP Address' },
      { field: 'GeneralSoftwareVersion', header: 'Software Version' },
      { field: 'ActuatorVersion', header: 'Module 1' },
      { field: 'FunctionalVersion', header: 'Module 2' },
      { field: 'FullName', header: 'Modified By' },

    ]
    this.SecheduleHistoryColumns = [
      { field: 'DateModified', header: 'Date' },
      { field: 'Active', header: 'Active' },
      { field: 'OverrideReason', header: 'Override Reason' },
      { field: 'FullName', header: 'Modified By' },

    ];

  }

  public hasTicketLinkPermission()
  {
    let result:Boolean = true;
    if("ANALYST,HHD".split(",").indexOf(this.bartRoleCode)>-1)
    {
      result= false;      
    }
    return result
  }
  public showDialog() {
    this.RepairResultHistoryData=[];
    this.EuqipmentHistory=[];
    this.ScheduleHistory=[];
    this.index=0;
    this.display = true;
    this.getRepairResults();
  }
  public clkModify() {   
    this.IsEditable = true;   
      this.showScheduleOverRideReason=false;
    
    //IF THIS ISN'T A DIALYSIS MACHINE REMOVE THE EQUIPMENT HOURS FIELD
			if(this.SelectedRowData.EquipmentTypeDescription == 'Dialysis Machine'){
        this.HoursIsEditable = true;
      }
      else
      {
        this.HoursIsEditable = false;
      }

    this.IsViewMode = false;
    this.GetModel();
    this.GetModelInfo();
  }
  public getUserLocationId(emittedLocationId: string) {
    this.IsVisible = false;
    this.FaceilityMangerParams.SearchTerm = null;
    this.FaceilityMangerParams.facilityMasterIdList = emittedLocationId;
    this.GetFaceilityManger();
    this.searchtb.reset()
    this.searchtb._sortOrder = 1;
    this.searchtb.sortField = 'modelNumber';

  }
  public GetFaceilityManger() {
    this.FaceilityMangerData = [];
    this.Loding = true;
    this.FaceilityMangerParams.UserName = this.userName;
    var GETFACILITYEQUIPMENTMANAGER = this.FaceilityMangerParams;
    this._EquipmentService.getFaceilityManger(JSON.stringify({ GETFACILITYEQUIPMENTMANAGER }))
      .subscribe((Result: any) => {
        this.FaceilityMangerData = Result.facilityEquipment;
        this.FaceilityMangerData = this.FaceilityMangerData.sort((a, b) => a.modelNumber.toString() > b.modelNumber.toString() ? 1 : (a.modelNumber.toString() < b.modelNumber.toString() ? -1 : 0))
        this.Loding = false;
        this.isPaginatorVisible = true;
      },
        (respose: Response) => {
          this.Loding = false;
          // handle error here
        }
      );
  }
  public getRepairResults() {
    var GETREPAIRRESULTS = this.GetEquipmentID
    this._EquipmentService.getRepairResults(JSON.stringify({ GETREPAIRRESULTS }))
      .subscribe((Result: any) => {
        this.RepairResultHistoryData = Result.repairHistory;
        this.RepairResultHistoryData.forEach(item => item.DateServicePerformed = this.datePipe.transform(item.DateServicePerformed, "MM/dd/yyyy"));
      },
        (respose: Response) => {

          // handle error here
        }
      );
  }
  public getEquipmentHistoryResults() {
    var GETEQUIPMENTHISTORYRESULTS = this.GetEquipmentID;

    this._EquipmentService.getEquipmentHistoryResults(JSON.stringify({ GETEQUIPMENTHISTORYRESULTS }))
      .subscribe((Result: any) => {
        this.EuqipmentHistory = Result.facilityEquipment;
        this.EuqipmentHistory.forEach(item => item.DateLocationChanged = this.datePipe.transform(item.DateLocationChanged, "MM/dd/yyyy"));
      },
        (respose: Response) => {

          // handle error here
        }
      );
  }

  public GetEquipmentScheduleHistory() {
    var GETEQUIPMENTSCHEDULEHISTORY = this.GetEquipmentID;
    this._EquipmentService.getEquipmentScheduleHistory(JSON.stringify({ GETEQUIPMENTSCHEDULEHISTORY }))
      .subscribe((Result: any) => {
        this.ScheduleHistory = Result.equipmentSchedule;
      },
        (respose: Response) => {

          // handle error here
        }
      );
  }
  public GetEquipmentMpi() {
    this.EquipmentMpi = new MPI();

    var GETEQUIPMENTMPI = this.GetEquipmentID;
    this._EquipmentService.getEquipmentMpi(JSON.stringify({ GETEQUIPMENTMPI })).subscribe((Result: any) => {
      if (Result.equipmentMpi.length > 0) {
        
         let data: MPI;
        data = Result.equipmentMpi[0];
        this.EquipmentMpi = data;
        this.EquipmentMpi["MPI"] = data["PatientId"];
        this.EquipmentMpi["ConfirmMPI"] = this.EquipmentMpi["MPI"]
        if (data["StartDate"] != null) {
          //this.EquipmentMpi["StartDate"] = new Date(data["StartDate"]).toLocaleDateString();
          this.EquipmentMpi["StartDate"]=this.datePipe.transform(this.EquipmentMpi["StartDate"], "MM/dd/yyyy")
        }
        if (data["Enddate"] != null) {
          //this.EquipmentMpi["Endate"] = new Date(data["Enddate"]).toLocaleDateString();
          this.EquipmentMpi["Endate"] = this.datePipe.transform(this.EquipmentMpi["Enddate"], "MM/dd/yyyy")
        }

        this.DisableMpi = true;
      }
      else {
        // this.EquipmentMpi=[];
        this.DisableMpi = false;
        
      }
    },
      (respose: Response) => {

        // handle error here
      }
    );
  }
  public getModelSchedule() {    
    var GETMODELSCHEDULE = this.GetModelID;
    this._modelService.getModelSchedule(JSON.stringify({ GETMODELSCHEDULE }))
      .subscribe((Result: any) => {
        this.ModelSchedule = Result.maintenance;
        this.srText = "None";
        this.custText = "None";
        if (this.ModelSchedule.length > 0) {
          let md: any = this.ModelSchedule;

          let type = md[0].ScheduleTypeID;
          if (type == "1") {
            this.srText = md[0].ScheduleFrequencyDescription;
          }
          if(md.length>1)
          {
            let typecust = md[1].ScheduleTypeID;
            if (typecust == "2") {
              this.custText = md[1].ScheduleFrequencyDescription;
              if (md[0].ScheduleFrequencyId != "" && md[0].ScheduleFrequencyId != "1") {
                this.editCustomSchedule = true;
              }
            }
          }
        }
      },
        (respose: Response) => {

          // handle error here
        }
      );
  }
  public GetModelInfo() {

    var GETMODELINFO = this.GetModelID;
    this._modelService.getModelInfo(JSON.stringify({ GETMODELINFO }))
      .subscribe((Result: any) => {
        this.ModelInfo = Result.modelInfo;
      },
        (respose: Response) => {

          // handle error here
        }
      );
  }
  public GetModel() {
    var GETMODELS = this.GetManfactureID;
    this._modelService.getModels(JSON.stringify({ GETMODELS }))
      .subscribe((Result: any) => {
        this.model = Result.models;
      },
        (respose: Response) => {

          // handle error here
        }
      );
  }
  async UpdateEquipment() {      
    this.errors = '';
    this.GETEQUIPMENTSTATUSID.equipmentId = this.GetEquipmentID.EquipmentID;
    this.UPDATEEQUIPMENTLOCATION.equipmentId = this.GetEquipmentID.EquipmentID;
    this.UPDATEEQUIPMENTLOCATION.equipmentStatusId = this.SelectedRowData["equipmentstatusid"];
    this.UPDATEEQUIPMENTLOCATION.dateModified = this.SelectedRowData["DateModified"];
    this.UPDATEEQUIPMENTLOCATION.facilityMasterId = this.SelectedRowData["facilityMasterid"];
    this.UPDATEEQUIPMENTLOCATION.userid = this.userId
    this.UPDATEEQUIPMENTLOCATION.locationdescription = "";
    this.UpdateEquipmentData.ActuatorVersion = "";
    this.UpdateEquipmentData.FunctionalVersion = "";
    this.UpdateEquipmentData.MachineIPAddress = "";
    this.UpdateEquipmentData.MachineNickName = this.SelectedRowData["MachineNickName"];
    this.UpdateEquipmentData.dateOfOriginalInstall = this.SelectedRowData["dateOfOriginalInstall"];
    this.UpdateEquipmentData.dateWarrantyExpires = this.SelectedRowData["dateWarrantyExpires"];
    this.UpdateEquipmentData.equipmentConditionId = this.SelectedRowData["equipmentConditionId"];
    this.UpdateEquipmentData.equipmentDescription = this.SelectedRowData["equipmentdescription"];
    this.UpdateEquipmentData.equipmentId = this.GetEquipmentID.EquipmentID;
    this.UpdateEquipmentData.equipmentOriginId = this.SelectedRowData["equipmentOriginId"];
    this.UpdateEquipmentData.equipmentModalityId = this.SelectedRowData["equipmentModalityId"];
    this.UpdateEquipmentData.equipmentSerialNumber = this.SelectedRowData["equipmentserialnumber"];
    this.UpdateEquipmentData.equipmentStatusId = this.SelectedRowData["equipmentstatusid"];    
    this.UpdateEquipmentData.isCustomScheduleActiveFlag = this.SelectedRowData.isCustomScheduleActiveFlag==true?1:0
    this.UpdateEquipmentData.isPMScheduleActiveFlag = "";
    this.UpdateEquipmentData.lastClockHours = this.SelectedRowData["clockhours"];
    this.UpdateEquipmentData.modelId = this.SelectedRowData["modelId"];
    this.UpdateEquipmentData.userid = this.userId;
    //  this.UpdateEquipmentData.comment= this.StatusReasonCodeComment;
    var fieldsValid = this.validateEquipmentFields(this.UpdateEquipmentData, this.EquipmentMpi);

    if (this.UpdateEquipmentData.modelId == undefined || this.UpdateEquipmentData.modelId == "") 
    {
      this.errors += 'You must choose a model.,';
      this.ValidationMsgDailogbox = true;
    }
    else if(this.UpdateEquipmentData.equipmentSerialNumber == undefined || this.UpdateEquipmentData.equipmentSerialNumber == "") 
    {
      this.errors += 'You must choose a SN / IntID.,';
      this.ValidationMsgDailogbox = true;
    }
    else 
    {
      //check serial number
      if (this.UpdateEquipmentData.modelId != undefined && this.UpdateEquipmentData.modelId != "") {
        let validSerial: any = []
        validSerial = this.checkEquipmentSerial((isValidSerial)=>{
           if(isValidSerial && fieldsValid)
           {
            //if (this.SelectedRowData["isCustomScheduleActiveFlag"]) {
              this.AddEquipmentSchedule();
            //}
            this.isDirtyMpi = 1;
            if (this.EquipmentMpi["MPI"]) {
              //this.isDirtyMpi = await this.InsertUpdateMPI();
                this.InsertUpdateMPI(); //Defect#12436
            }
            // if (this.isDirtyMpi) {
              var UPDATEEQUIPMENT = this.UpdateEquipmentData;
              var GETEQUIPMENTSTATUSID = this.GETEQUIPMENTSTATUSID;
              var GETEQUIPMENTLOCATIONID = this.GETEQUIPMENTSTATUSID;
              var UPDATEEQUIPMENTLOCATION = this.UPDATEEQUIPMENTLOCATION;
              this._EquipmentService.updateEuipment(JSON.stringify({ UPDATEEQUIPMENT, GETEQUIPMENTSTATUSID, GETEQUIPMENTLOCATIONID, UPDATEEQUIPMENTLOCATION }))
                .subscribe((Result: any) => {
      
                  this.model = Result;
                  this.IsEditable = false;
                  this.IsViewMode = true;
                  this.IsVisible = false;
                  this.FaceilityMangerData = null;
                  this.SelectedRowData = null;
                  this.GetFaceilityManger();
                  this.HeaderText = 'Success';
                  this.Alertmessage = 'Item successfully updated!';
                  this.Alertpopup = true;                 
                  //  this.EquipmentMpi=[];
                },
                  (respose: Response) => {
      
                    // handle error here
                  }
                );
      
            // }
           }
        else 
          {
            this.ValidationMsgDailogbox = true;
          }

        });
        // Based on validation, need to setup the value as false for
        // fieldsValid = false;
      }
    }

  }
  public OnRowClick() {
    this.showScheduleOverRideReason=false;
    this.SelectedRowData == null;
    this.IsVisible = true;
    this.IsEditable = false;
    this.IsViewMode = true;
    let RowData: any = this.selectedEquipmentData;
    this.SelectedRowData = RowData;
    this.SelectedRowData["equipmentserialnumber"] = this.SelectedRowData["EquipmentSerialNumber"];
    this.SelectedRowData["equipmentdescription"] = this.SelectedRowData["equipmentDescription"];
    this.SelectedRowData["dateWarrantyExpires"] = this.SelectedRowData["DateWarrantyExpires"];
    this.SelectedRowData["dateOfOriginalInstall"] = this.SelectedRowData["DateOfOriginalInstall"];
    this.SelectedRowData["modelId"] = this.SelectedRowData["ModelID"]; 
    
    this.GetModelID.ModelID = this.SelectedRowData["modelId"];
    this.GetEquipmentID.EquipmentID = this.SelectedRowData["EquipmentID"];
    this.GetManfactureID.manufacturerId = this.SelectedRowData["ManufacturerID"];
    if (this.SelectedRowData["isCustomScheduleActiveFlag"]) {
      this.EnableCustomSchedule = true;
    }
    else {
      this.EnableCustomSchedule = false;
    }
    this.GetEquipmentMpi();
    this.getModelSchedule();
    this.getModelDroDown();
  }
  public getKeyword(emittedKeyword: string) 
  {
    if (emittedKeyword.length > 2) 
    {
      this.IsVisible = false;
      this.FaceilityMangerParams.facilityMasterIdList="0";
      this.FaceilityMangerParams.SearchTerm = emittedKeyword;
      this._facilityService.getUserLocationFacilities(this.userName,(facilities:UserLocationFacility[])=>
      {
        let objUserFacilities:UserLocationFacility[]=facilities
        if(objUserFacilities!=null && objUserFacilities.length>0)
        {
          this.FaceilityMangerParams.facilityMasterIdList=objUserFacilities.map(x => x.FacilityMasterID).join(", ");
        }
        this.GetFaceilityManger();
        this.searchtb.reset()
        this.searchtb._sortOrder = 1;
        this.searchtb.sortField = 'modelNumber';
      });
    }
    else 
    {
      this.Alertpopup = true
      this.HeaderText = 'Error'
      this.Alertmessage = 'Search term must be at least three characters.'
    }

  }

  // public getUserFacility(){
  //     this.btnLocationClicked.emit(this.selectedFacility);
  //   }
  public TabChange(event: any) {
    this.index=event.index;
    if (event.index == 0) {
      this.getRepairResults();
    }
    if (event.index == 1) {
      this.getEquipmentHistoryResults();
    }
    if (event.index == 2) {
      this.GetEquipmentScheduleHistory();
    }
  }
  GetManufacturar() {
    var GETMANUFACTURERS = this.Parameters
    this._manufacturerService.getManufacturers(JSON.stringify({ GETMANUFACTURERS }))
      .subscribe((allManufacturesResponse: any) => {
        if (allManufacturesResponse.manufacturers.length > 0)
          this.manufacturarsList = [];
        for (let c of allManufacturesResponse.manufacturers) {
          this.manufacturarsList.push({ label: c.ManufacturerName, value: c.ManufacturerID });;
        }

      }, (respose: Response) => {
        this.manufacturarsList = [];
        // handle error here
      }
      );

  }

  GetEquipmentStatus() {
    this._EquipmentService.getEquipmentStatus().subscribe((allEquipmentStatusResponse: any) => {

      
      if (allEquipmentStatusResponse.status.length > 0)
        this.StatusList = [];
      for (let S of allEquipmentStatusResponse.status) {
        this.StatusList.push({ label: S.EquipmentStatusDescription, value: S.EquipmentStatusId });;
      }
    }, (respose: Response) => {
      this.StatusList = [];
      // handle error here
    }
    );
  }
  getModelDroDown() {
    
    var GETMODELS = this.GetManfactureID;
    this._modelService.getModels(JSON.stringify({ GETMODELS })).subscribe((allModelResponse: any) => {
      
      if (allModelResponse.models.length > 0)

        this.ModelList = [];
      for (let M of allModelResponse.models) {
        this.ModelList.push({ label: M.modelnumber, value: M.modelid });;
      }
    }, (respose: Response) => {
      this.ModelList = [];
      // handle error here
    }
    );
  }
  getEquipmentModality() {
    this._EquipmentService.getEquipmentModality().subscribe((allEquipmentModalitylResponse: any) => {
      if (allEquipmentModalitylResponse.equipmentModality.length > 0)

        this.ModalityList = [];
      for (let MD of allEquipmentModalitylResponse.equipmentModality) {
        this.ModalityList.push({ label: MD.ModalityDescription, value: MD.EquipmentModalityId });;

      }
    }, (respose: Response) => {
      this.ModalityList = [];
      // handle error here
    }
    );
  }
  getEquipmentConditions() {
    this._EquipmentService.getEquipmentConditions().subscribe((allEquipmentConditionlResponse: any) => {

      if (allEquipmentConditionlResponse.conditions.length > 0)
        this.ConditionList = [];
      for (let con of allEquipmentConditionlResponse.conditions) {
        this.ConditionList.push({ label: con.EquipmentConditionDescription, value: con.EquipmentConditionId });;
      }
    }, (respose: Response) => {
      this.ConditionList = [];
      // handle error here
    }
    );
  }

  getEquipmentOrigins() {
    this._EquipmentService.getEquipmentOrigins().subscribe((allEquipmentOriginsResponse: any) => {
      if (allEquipmentOriginsResponse.origins.length > 0)
        this.OriginList = [];
      for (let c of allEquipmentOriginsResponse.origins) {
        this.OriginList.push({ label: c.EquipmentOriginDescription, value: c.EquipmentOriginId });;
      }
    }, (respose: Response) => {
      this.OriginList = [];
      // handle error here
    }
    );
  }
  async InsertUpdateMPI() {
    let Isvalid = 0;
    this.EquipmentMpi["EquipmentID"] = this.GetEquipmentID.EquipmentID;
    this.UpdateMPIData.EquipmentID = this.EquipmentMpi["EquipmentID"]
    if (this.EquipmentMpi["EquipPatientId"] != undefined) {
      this.UpdateMPIData.EquipPatientID = this.EquipmentMpi["EquipPatientId"]
    }
    else { this.UpdateMPIData.EquipPatientID = null }
    if (this.EquipmentMpi["MPI"] != undefined) {
      this.UpdateMPIData.PatientID = this.EquipmentMpi["MPI"]
    }
    else {
      this.UpdateMPIData.PatientID = null
    }
    if (this.EquipmentMpi["StartDate"] != undefined) {
     
      this.UpdateMPIData.StartDate =  this.datePipe.transform(this.EquipmentMpi["StartDate"], "MM/dd/yyyy")
    }
    else {
      this.UpdateMPIData.StartDate = null
    }
    if (this.EquipmentMpi["EndDate"] != undefined) {
      this.UpdateMPIData.EndDate = this.datePipe.transform(this.EquipmentMpi["EndDate"], "MM/dd/yyyy");
    }
    else {
      this.UpdateMPIData.EndDate = null
    }
    var INSERTUPDATEEQUIPMENTMPI = this.UpdateMPIData;


    await this._EquipmentService.inserUpdateMPI(JSON.stringify({ INSERTUPDATEEQUIPMENTMPI }))
      .then((Result: any) => {
        if (Result.equipmentMpi != null && Result.equipmentMpi != undefined) {
          Isvalid = 1
        }
        else if(Result.errors!=null && Result.errors!=undefined)
        {
          this._messageService.showAlertMessage("Equipment MPI Update Failed. "+Result.errors);
        }
        else 
        {
          this.ValidationMsgDailogbox = true;
          this.errors = Result
          Isvalid = 0
        }

      },
        (error) => {
          this._messageService.showAlertMessage("Equipment MPI Update Failed. "+error.error.errors);
        }
      );
    return Isvalid

  }
  AddEquipmentSchedule() {    
    this.EquipmentSchedulePara.EquipmentId = this.GetEquipmentID.EquipmentID; 
    this.EquipmentSchedulePara.isScheduleActiveFlag = this.SelectedRowData.isCustomScheduleActiveFlag==true?1:0;
    this.EquipmentSchedulePara.OverrideReason = this.SelectedRowData["OverrideReason"];    
    this.EquipmentSchedulePara.userId=this.userId;

    var ADDEQUIPMENTSCHEDULE = this.EquipmentSchedulePara;
    this._EquipmentService.addEquipmentSchedule(JSON.stringify({ ADDEQUIPMENTSCHEDULE }))
      .subscribe((Result: any) => {
        if (Result != "" || Result != undefined) {

        }
        else {
          this.errors = Result;
          this.ValidationMsgDailogbox = true;

        }
      },
        (respose: Response) => {

          // handle error here
        }
      );

  }

  FnConvertDateFormat(dateValue: Date) {
    return (dateValue.getMonth() + 1) + '/' + dateValue.getDate() + '/' + dateValue.getFullYear();
  }
  validateEquipmentFields(equipData, MpipData) {
    this.equipStatusChanged = false;//Status DropDown Changed

    var isValid = false;
    var msg = "";
    var lastClockHours = equipData.lastClockHours;
    lastClockHours = "";
    this.errors;
    // resizeBartDialog('equipmentSearchGenericDialog',250,80);

    
    // if (equipData.lastClockHours == "" || equipData.lastClockHours ==undefined || equipData.lastClockHours ==null) {
    //   this.errors+='Hours on Machine cannot be blank.,';
    // }
    //check the state of the checkbox    
    if (this.showScheduleOverRideReason) {
      if (this.SelectedRowData.OverrideReason == "" || this.SelectedRowData.OverrideReason==undefined) {
        this.errors += 'Schedule Override Reason cannot be blank.,';
      }
    }    
    // if (this.isEmpty(MpipData.MPI) != this.isEmpty(MpipData.ConfirmMPI)) {      
      if (MpipData.MPI != MpipData.ConfirmMPI) {
      this.errors += 'MPI and Confirm MPI must be the same.,';
    }

    if (MpipData.MPI != undefined && MpipData.ConfirmMPI != undefined && MpipData.StartDate == undefined) {
      this.errors += 'MPI and Start Date are required.,';
    }

    if (this.equipStatusChanged && MpipData.MPI != "" && MpipData.ConfirmMPI != "" && MpipData.StartDate != "" && MpipData.Enddate == "") {
      this.errors += 'End Date required when changing status.,';
    }

    if (this.errors.length > 1) {
      isValid = false;
    }
    else {
      isValid = true;
    }
    return isValid;
  }

   isEmpty(value:any){
    return (typeof value === "undefined" || value === null || value === "");
}

  checkEquipmentSerial(callBack) {

    this.validateSerialPara.ModelID = this.SelectedRowData["modelId"];
    this.validateSerialPara.serial = this.SelectedRowData["equipmentserialnumber"]
    this.validateSerialPara.strippedSerial = this.SelectedRowData["equipmentserialnumber"]
    let EqID: any = this.GetEquipmentID.EquipmentID;

    var VALIDATESERIAL = this.validateSerialPara;

    this._EquipmentService.validateSerial(JSON.stringify({ VALIDATESERIAL }))
      .subscribe((Result: any) => {
        if (Result.valSerial.length > 0) {

          if (EqID == Result.valSerial[0].equipmentId) {
            this.ret.Status = true;
            callBack(true)
          }
          else {
            this.ValidationMsgDailogbox = true;
            this.ret.Status = false;
            this.errors += 'The serial number entered was not unique for the selected model.';

            if (Result.valSerial.length > 0) {
              this.errors += "The serial number has been found at the following facilities:,"
              for (let a = 0; a < Result.valSerial.length; a++) {
                this.errors += Result.valSerial[a].facilityNumber + ' - ' + Result.valSerial[a].facilityName + ' (' + Result.valSerial[a].equipmentSerialNumber + '),';
              }
            }
            this.ret.msg += 'You must enter a unique serial number to continue.,';
            callBack(false)
          }
        } 
        else
         {
          // this.errors += 'Error checking serial number.,';
          // this.ret.Status = false;
          callBack(true)
        }
        return this.ret.Status;
      },
        (respose: Response) => {

          // handle error here
        }
      );
  }
  onStatusChange(event: any) {
    this.equipStatusChanged = true;
    if (event.value == 2) {
      this.StausDailogbox = true;
    }
  }
  onmanufacturarChange(event: any) {
    /* ALM Defect ID (12424 && 12405) */
    this.SelectedRowData["modelId"] = null;
    this.GetManfactureID.manufacturerId = event.value;
    this.getModelDroDown();
  }
  StatusCommentPopup() {
    this.StausDailogbox = false;
  }
  onlyNumberKey(event) {
    return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }
  public ClosePopUp() {
    this.Alertpopup = false;
  }
  public mpiCorrection() {
    this.DisableMpi = false;
  }
  public onRowUnselect() {
    this.IsVisible = false
    this.selectedEquipmentData = [];
  }
  public CloseValidationPopUp() {
    this.ValidationMsgDailogbox = false;
  }
  public hasPermission(btnName) {
    let result: Boolean = false
    if (btnName == "Modify" && "ADMIN,BOM,BOMX,HHD".split(",").indexOf(this.bartRoleCode) > -1) {
      result = true;

    }
    return result
  }
  reset() {
    this.first = 0;
  }
public enableDisableEqupFields(controlId:any)
{
  var fields=this.FIELDPRIVS[this.bartRoleCode]
  var fieldArray = fields.split(',');
  if(fieldArray.indexOf(controlId) !== -1){
    return true;
} else{
  return false;
} 

}
setScheduleOverRideReason()
{  
  this.showScheduleOverRideReason=!this.showScheduleOverRideReason;
}

public hasNotBOMXPermission()  /* ALM Defect ID 12769 */
{
  let result:Boolean=false
  if(this.bartRoleCode!="BOMX")
  {
    result= true;
    
  }
  return result
}

}





